export function trackEvent(name, data) {
  try {
    // Use the queue installed in public/index.html, including before it loads.
    window.va?.("event", { name, data });
  } catch {
    // Analytics must never interrupt playback or timer controls.
  }
}
